/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { getCacheData } from "../../services/CacheService";
import { saveBlockProducto } from "../../services/BlockProductoService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  id: null,
  idBlCrTipo: null,
  idBlCrMaterial: null,
  idBlCrMarca: null,
  idBlCrColor: null,
  idBlCrDiametro: null,
  descripcion: "",
  descripcionCorta: "",
  conAdicion: false,
  observaciones: "",
};

const nameItemText = "Producto de Block";
const itemGender = "M";
//
// ########################################################################### 
//
const BlockProductoDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [blCrTipos, setBlCrTipos] = useState([]);
  const [blCrMateriales, setBlCrMateriales] = useState([]);
  const [blCrMarcas, setBlCrMarcas] = useState([]);
  const [blCrColores, setBlCrColores] = useState([]);
  const [blCrDiametros, setBlCrDiametros] = useState([]);
  const [valueACBlCrTipo, setValueACBlCrTipo] = useState
    (
      itemCrud.blCrTipo
    )
  const [inputValueACBlCrTipo, setInputValueACBlCrTipo] = useState("");
  const [valueACBlCrMaterial, setValueACBlCrMaterial] = useState
    (
      itemCrud.blCrMaterial
    )
  const [inputValueACBlCrMaterial, setInputValueACBlCrMaterial] = useState("");
  const [valueACBlCrMarca, setValueACBlCrMarca] = useState
    (
      itemCrud.blCrMarca
    )
  const [inputValueACBlCrMarca, setInputValueACBlCrMarca] = useState("");
  const [valueACBlCrColor, setValueACBlCrColor] = useState
    (
      itemCrud.blCrColor
    )
  const [inputValueACBlCrColor, setInputValueACBlCrColor] = useState("");
  const [valueACBlCrDiametro, setValueACBlCrDiametro] = useState
    (
      itemCrud.blCrDiametro
    )
  const [inputValueACBlCrDiametro, setInputValueACBlCrDiametro] = useState("");

  //
  // ################################################################################
  // 
  useEffect(() => {
    loadBlCrTipos();
    loadBlCrMateriales();
    loadBlCrMarcas();
    loadBlCrColores();
    loadblCrDiametros();

    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  // 
  useEffect(() => {

    let _blCrTipo = valueACBlCrTipo ? valueACBlCrTipo.label + " | " : "";
    let _blCrMarca = valueACBlCrMarca ? valueACBlCrMarca.label + " | " : "";
    let _blCrMaterial = valueACBlCrMaterial ? valueACBlCrMaterial.label + " | " : "";
    let _blCrColor = valueACBlCrColor ? valueACBlCrColor.label + " | " : "";
    let _blCrDiametro = valueACBlCrDiametro ? valueACBlCrDiametro.label : "";
    let _descripcion = _blCrTipo + _blCrMarca + _blCrMaterial + _blCrColor + _blCrDiametro;

    setItemCrudLocal((prev) => ({
      ...prev,
      descripcion: _descripcion,
    }));
  }, [valueACBlCrTipo, valueACBlCrMarca, valueACBlCrMaterial, valueACBlCrColor, valueACBlCrDiametro]);
  //
  // ################################################################################
  //
  const loadBlCrMarcas = async () => {
    const response = await getCacheData("bl_cr_marca");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrMarcas(_var);
    } else {
      setBlCrMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrMateriales = async () => {
    const response = await getCacheData("bl_cr_material");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrMateriales(_var);
    } else {
      setBlCrMateriales([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrTipos = async () => {
    const response = await getCacheData("bl_cr_tipo");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrTipos(_var);
    } else {
      setBlCrTipos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrColores = async () => {
    const response = await getCacheData("bl_cr_color");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrColores(_var);
    } else {
      setBlCrColores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadblCrDiametros = async () => {
    const response = await getCacheData("bl_cr_diametro");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: String(item.valor),
        });
      });
      setBlCrDiametros(_var);
    } else {
      setBlCrDiametros([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {

      if (!valueACBlCrTipo) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el Tipo del Producto",
        });
        setShowMessage(true);
        return;
      }

      if (!valueACBlCrMaterial) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el Material del Producto",
        });
        setShowMessage(true);
        return;
      }

      if (!valueACBlCrMarca) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar la Marca del Producto",
        });
        setShowMessage(true);
        return;
      }

      if (!valueACBlCrColor) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el Color del Producto",
        });
        setShowMessage(true);
        return;
      }

      if (!valueACBlCrDiametro) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el Diámetro del Producto",
        });
        setShowMessage(true);
        return;
      }

      if (!itemCrudLocal.descripcion) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar la Descripción del Producto",
        });
        setShowMessage(true);
        return;
      }

      if (!itemCrudLocal.descripcionCorta) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar la Descripción abreviada del Producto",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {
    let _itemCrud = {
      id_bl_cr_tipo: valueACBlCrTipo.id,
      id_bl_cr_material: valueACBlCrMaterial.id,
      id_bl_cr_marca: valueACBlCrMarca.id,
      id_bl_cr_color: valueACBlCrColor.id,
      id_bl_cr_diametro: valueACBlCrDiametro.id,
      descripcion: itemCrudLocal.descripcion,
      descripcion_corta: itemCrudLocal.descripcionCorta,
      con_adicion: itemCrudLocal.conAdicion,
      observaciones: itemCrudLocal.observaciones,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrud.id;
    }

    setIsDoingSomething(true);
    const response = await saveBlockProducto(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-tipo"
                size="small"
                value={
                  valueACBlCrTipo && valueACBlCrTipo.id
                    ? valueACBlCrTipo
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACBlCrTipo(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idBlCrTipo: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACBlCrTipo}
                onInputChange={(event, newInputValue) => {
                  setInputValueACBlCrTipo(newInputValue);
                }}
                options={blCrTipos}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Tipo" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-material"
                size="small"
                value={
                  valueACBlCrMaterial && valueACBlCrMaterial.id
                    ? valueACBlCrMaterial
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACBlCrMaterial(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idBlCrMaterial: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACBlCrMaterial}
                onInputChange={(event, newInputValue) => {
                  setInputValueACBlCrMaterial(newInputValue);
                }}
                options={blCrMateriales}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Material" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-marca-producto"
                size="small"
                value={
                  valueACBlCrMarca && valueACBlCrMarca.id
                    ? valueACBlCrMarca
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACBlCrMarca(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idBlCrMarca: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACBlCrMarca}
                onInputChange={(event, newInputValue) => {
                  setInputValueACBlCrMarca(newInputValue);
                }}
                options={blCrMarcas}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Marca del Producto" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-color"
                size="small"
                value={
                  valueACBlCrColor && valueACBlCrColor.id
                    ? valueACBlCrColor
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACBlCrColor(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idBlCrColor: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACBlCrColor}
                onInputChange={(event, newInputValue) => {
                  setInputValueACBlCrColor(newInputValue);
                }}
                options={blCrColores}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Color" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-diametro"
                size="small"
                value={
                  valueACBlCrDiametro && valueACBlCrDiametro.id
                    ? valueACBlCrDiametro
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACBlCrDiametro(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idBlCrDiametro: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACBlCrDiametro}
                onInputChange={(event, newInputValue) => {
                  setInputValueACBlCrDiametro(newInputValue);
                }}
                options={blCrDiametros}
                getOptionLabel={(option) => (option.label).toString() || ""}
                renderInput={(params) => <TextField {...params} label="Diámetro" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={itemCrudLocal.conAdicion ?? false}
                    onChange={handleChange}
                    name="conAdicion"
                    color="primary"
                    disabled={
                      actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                    }
                  />
                }
                label="Con Adición"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="descripcion"
                label="Descripción"
                variant="outlined"
                size="small"
                name="descripcion"
                value={itemCrudLocal.descripcion}
                onChange={handleChange}
                // disabled={
                //   actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                // }
                disabled={true}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="descripcion_corta"
                label="Descripción Abreviada"
                variant="outlined"
                size="small"
                name="descripcionCorta"
                value={itemCrudLocal.descripcionCorta}
                onChange={handleChange}
                onFocus={() => {
                  if (itemCrudLocal.descripcionCorta === "") {
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      descripcionCorta: itemCrudLocal.descripcion,
                    });
                  }
                }}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off"
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={itemCrudLocal.observaciones}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
                multiline
                rows={3}
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: '80px'
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  onClick={handleSave}
                  color={actionCrud === "disable" ? "error" : "primary"}
                  startIcon={
                    actionCrud === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : actionCrud === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {actionCrud === "disable"
                    ? "Deshabilitar"
                    : actionCrud === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>

                <Button
                  variant="outlined"
                  onClick={handleCloseDialog}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog >

      < WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default BlockProductoDialog;
